import React from "react";
import { IDocumentId } from "../../Document.props";
import EditDocument from "./EditDocument";



const EditDocumentIndex: React.FC<IDocumentId> = ({ documentId ,setMethod}) => {

    return (
        <EditDocument documentId={documentId} setMethod={setMethod}/>
    );
}

export default EditDocumentIndex;
